var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column justify-content-start col-lg-3 acknowledgement-wrap"
    },
    [
      !_vm.claim.acknowledgement_sent
        ? _c("div", { staticClass: "acknowledgement-not-sent" }, [_vm._m(0)])
        : _vm.claim.acknowledgement_sent && !_vm.mailSentAmountEntered
          ? _c("div", { staticClass: "acknowledgement-sent" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-end align-items-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "go-to-claim",
                      on: {
                        click: function($event) {
                          _vm.view($event, _vm.claim.id)
                        }
                      }
                    },
                    [_vm._v("\n        Go to claim\n      ")]
                  )
                ]
              )
            ])
          : _vm.mailSentAmountEntered && !_vm.claim.settlement_email_sent
            ? _c("div", { staticClass: "gray-box" }, [
                _vm._m(2),
                _vm._v(" "),
                _vm.claim.settlement_amounts.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "span",
                            { staticClass: "settlement-amount-name" },
                            [
                              _vm._v("\n          Office\n          "),
                              _c("i", {
                                staticClass: "fa",
                                class: [
                                  _vm.claim.settlement_amounts[0]
                                    .settlement_status.name === "Approved"
                                    ? "fa-check-circle approved-icon"
                                    : _vm.claim.settlement_amounts[0]
                                        .settlement_status.name === "Declined"
                                      ? "fa-times-circle denied-icon"
                                      : ""
                                ]
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n          $" +
                                _vm._s(_vm.claim.settlement_amounts[0].amount) +
                                "\n        "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "span",
                            { staticClass: "settlement-amount-name" },
                            [
                              _vm._v("\n          Subco\n          "),
                              _c("i", {
                                staticClass: "fa",
                                class: [
                                  _vm.claim.settlement_amounts[1]
                                    .settlement_status.name === "Approved"
                                    ? "fa-check-circle approved-icon"
                                    : _vm.claim.settlement_amounts[1]
                                        .settlement_status.name === "Declined"
                                      ? "fa-times-circle denied-icon"
                                      : ""
                                ]
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n          $" +
                                _vm._s(_vm.claim.settlement_amounts[1].amount) +
                                "\n        "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "span",
                            { staticClass: "settlement-amount-name" },
                            [_vm._v("\n          Total approved\n        ")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n          $" +
                                _vm._s(_vm.claim.settlement_amount) +
                                "\n        "
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            : _vm.mailSentAmountEntered && _vm.claim.settlement_email_sent
              ? _c(
                  "div",
                  {
                    staticClass: "gray-box",
                    class: [
                      {
                        "green-border": _vm.claim.settlement_customer_approved
                      },
                      { "red-border": !_vm.claim.settlement_customer_approved },
                      {
                        "no-border": !_vm.claim.hasOwnProperty(
                          "settlement_customer_approved"
                        )
                      }
                    ]
                  },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "settlement-amount-sent",
                            class: [
                              {
                                "green-text":
                                  _vm.claim.settlement_customer_approved
                              },
                              {
                                "red-text": !_vm.claim
                                  .settlement_customer_approved
                              },
                              {
                                "no-color": !_vm.claim.hasOwnProperty(
                                  "settlement_customer_approved"
                                )
                              }
                            ]
                          },
                          [
                            !_vm.claim.hasOwnProperty(
                              "settlement_customer_approved"
                            )
                              ? _c("span", [
                                  _c("strong", [
                                    _vm._v(
                                      "$" + _vm._s(_vm.claim.settlement_amount)
                                    )
                                  ]),
                                  _vm._v(
                                    " settlement offer emailed to the customer.\n        "
                                  )
                                ])
                              : _vm.claim.settlement_customer_approved
                                ? _c("span", [
                                    _vm._v(
                                      "\n          Customer accepted settlement amount of"
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        " $" +
                                          _vm._s(_vm.claim.settlement_amount)
                                      )
                                    ])
                                  ])
                                : !_vm.claim.settlement_customer_approved
                                  ? _c("span", [
                                      _vm._v(
                                        "\n          Customer declined settlement amount of"
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          " $" +
                                            _vm._s(_vm.claim.settlement_amount)
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showEmailModal
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("send-claim-email", {
                  staticClass: "sidebar-right",
                  attrs: { list: true, job: _vm.claim, "type-id": 2 },
                  on: {
                    update: function($event) {
                      _vm.$emit("update")
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c("span", { staticClass: "ack-message" }, [
        _c("i", { staticClass: "fa fa-exclamation-triangle ack-icon-warning" }),
        _vm._v("\n        Acknowledgement email has not been sent yet.\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c("span", { staticClass: "ack-message" }, [
        _c("i", { staticClass: "fa fa-envelope ack-icon" }),
        _vm._v("\n        Acknowledgement email has been sent.\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-2" }, [
      _c("span", { staticClass: "settlement-amount" }, [
        _vm._v("\n        Settlement amount\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mb-2" }, [
      _c("span", { staticClass: "settlement-amount" }, [
        _vm._v("\n        Settlement amount\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b15822f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b15822f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimsBlockSettlementAmount.vue
// module id = null
// module chunks = 